import { render, staticRenderFns } from "./GiftSerial.vue?vue&type=template&id=e71ad2e4&scoped=true&"
import script from "./GiftSerial.vue?vue&type=script&lang=js&"
export * from "./GiftSerial.vue?vue&type=script&lang=js&"
import style0 from "./GiftSerial.vue?vue&type=style&index=0&id=e71ad2e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71ad2e4",
  null
  
)

export default component.exports